export class Categorie {
  public name: string;
  public code: string;
  public total_cours: number;
  public note_total: number;
  public note_pass: number;
  public note_rep: number;
  public note_exc: number;
  public is_calc: boolean;
  public is_number: boolean;
  public map: number = 300;


  /**
   * Create a new Categorie instance.
   *
   * @param code - A unique code identifier for the category.
   * @param name - The name of the category.
   * @param note_total - Maximum possible note.
   * @param note_pass - Minimum score required to pass.
   * @param note_rep - Score below which a student is considered failing.
   * @param note_exc - Score that represents excellent performance.
   * @param is_calc - Whether the category is included in calculations.
   * @param is_number - Whether the grading is numerical (default is true).
   * @param total_cours - Total number of courses in this category.
   */
  constructor(
    code: string,
    name: string,
    note_total: number,
    note_pass: number,
    note_rep: number,
    note_exc: number,
    is_calc: boolean,
    is_number: boolean = true,
    total_cours: number
  ) {
    this.code = code;
    this.name = name;
    this.note_total = note_total;
    this.note_pass = note_pass;
    this.note_rep = note_rep;
    this.note_exc = note_exc;
    this.is_calc = is_calc;
    this.is_number = is_number;
    this.total_cours = total_cours;
  }


}
